export function validateAvatarFile(file) {
  if (!file) return "Selecione uma imagem.";
  if (!file.type?.startsWith("image/")) {
    return "Envie apenas arquivos de imagem.";
  }
  if (file.size > 1_500_000) {
    return "A imagem deve ter no maximo 1,5 MB.";
  }
  return null;
}

export function readFileAsDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ""));
    reader.onerror = () => reject(new Error("Falha ao ler a imagem."));
    reader.readAsDataURL(file);
  });
}
